import * as Link from './Link'

export default Link
